import React from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import { GoogleOAuthProvider } from '@react-oauth/google'

import { Text, TextWrapper, Or } from 'components/layouts/signIn/components'
import Submit from 'components/buttons/submit'
import useMedia from 'utils/hooks/useMedia'
import { SOCIAL } from '.config'
const GoogleSignIn = dynamic(() => import('components/social/google'), { ssr: false })
const LinkedInSignIn = dynamic(() => import('components/social/linkedIn'), { ssr: false })

export default function SignUpComponent ({ formik, userType, setInvestorTypeOpen, setSignUpType, label, type, onOpenSignUp }) {
  const isWide = useMedia({ minWidth: 991 })
  const isNotMobile = useMedia({ minWidth: 460 })

  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
      <div style={{ height: 10 }} />
      <Submit name={label} loading={formik.isSubmitting} variant={1} />
      <Or>Or</Or>
      <div className={isNotMobile ? 'flex' : ''}>
        <LinkedInSignIn
          userType={userType}
          isSignIn={type === 2}
          setInvestorTypeOpen={setInvestorTypeOpen}
          setSignUpType={setSignUpType} />
        <GoogleOAuthProvider clientId={SOCIAL.google.id}>
        <GoogleSignIn
          userType={userType}
          isSignIn={type === 2}
          setInvestorTypeOpen={setInvestorTypeOpen}
          setSignUpType={setSignUpType} />
        </GoogleOAuthProvider>
      </div>

      {/* tos */}
    <div style={isWide ? { marginTop: 70, display: 'flex', alignItems: 'center', flexDirection: 'column' } : { display: 'flex', alignItems: 'center', flexDirection: 'column', marginTop: 40 }}>
      { type === 1
        ? <div>
            <span className="tos">By continuing your agree to the</span> <a href="/tos" target="__blank">
              <span className="tos-link">Terms of Services</span>
            </a>
            <span className="tos"> &amp; </span>
            <a href="/privacy-policy" target="__blank">
              <span className="tos-link">Privacy Policy</span>
            </a>
          </div>
        : null }

      { type === 1
        ? <TextWrapper>
            <Text>Already have an account?</Text>&nbsp;<a href={'/sign-in'}><Text className="pointer" link>Login</Text></a>
          </TextWrapper>
        : type === 2
          ? <TextWrapper>
              <Text>Don’t have an account?</Text>&nbsp;<Text onClick={onOpenSignUp} className="pointer" link>Sign Up</Text>
            </TextWrapper>
          : null }
      </div>
    </div>
  )
}

SignUpComponent.propTypes = {
  formik: PropTypes.object,
  userType: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.number,
  setInvestorTypeOpen: PropTypes.func,
  onOpenSignUp: PropTypes.func,
  setSignUpType: PropTypes.func
}
